/**
 * Trie un tableau d'articles selon l'option de tri donnée.
 * Retourne un nouveau tableau trié (ne mute pas l'original).
 * Retourne le tableau original si sortOption === 'manual' ou tableau vide.
 */
export function sortArticles(articles, sortOption) {
  if (sortOption === 'manual' || !articles.length) return articles;

  const sorted = [...articles];
  sorted.sort((a, b) => {
    switch (sortOption) {
      case 'priceAsc':
        return (a.prix || 0) - (b.prix || 0);
      case 'priceDesc':
        return (b.prix || 0) - (a.prix || 0);
      case 'stockDesc': {
        const dateA = a.rawData?._stockedDate || a.rawData?.ti_createdAt || '';
        const dateB = b.rawData?._stockedDate || b.rawData?.ti_createdAt || '';
        return dateB.localeCompare(dateA);
      }
      case 'stockAsc': {
        const dateA = a.rawData?._stockedDate || a.rawData?.ti_createdAt || '';
        const dateB = b.rawData?._stockedDate || b.rawData?.ti_createdAt || '';
        return dateA.localeCompare(dateB);
      }
      default:
        return 0;
    }
  });
  return sorted;
}
